export default __webpack_public_path__ + "static/media/img (1).32c984b3.jpg";